﻿import { Component, Input } from '@angular/core';

import { HTMLTooltipTypes } from './generic-HTML-tooltip-types';

@Component({
  selector: 'ld-generic-HTML-tooltip',
  templateUrl: 'generic-HTML-tooltip.template.html',
  styleUrls: [ './generic-HTML-tooltip.style.scss' ]
})
export class GenericHTMLTooltipComponent {
  public tooltipTypes = HTMLTooltipTypes;

  @Input() tooltipType: HTMLTooltipTypes;

  public getHeaderContent(): string {
    switch (this.tooltipType) {
      case HTMLTooltipTypes.bankStatement:
        return 'Please upload most recent bank statements:';
      case HTMLTooltipTypes.loanSummary:
        return 'How to upload documents:';
      case HTMLTooltipTypes.payStub:
        return 'Please upload most recent paystubs:';
      case HTMLTooltipTypes.photoID:
        return 'Please upload ONE of the following:';
      case HTMLTooltipTypes.W2:
        return 'Please upload most recent W2:';
      case HTMLTooltipTypes.propertyType:
        return 'Property Type';
      case HTMLTooltipTypes.purchaseDocuments:
        return 'Real Estate Purchase Agreement';
      case HTMLTooltipTypes.militaryServiceMembers:
        return 'Military Service Members';
      case HTMLTooltipTypes.maritalStatus:
        return 'Marital Status';
      case HTMLTooltipTypes.coBorrower:
        return 'Co-Borrower';
      case HTMLTooltipTypes.verifyCreditHistory:
        return 'Verify Credit History';
      case HTMLTooltipTypes.creditScore:
        return 'Credit Score';
      case HTMLTooltipTypes.downPayment:
        return 'Down Payment';
      case HTMLTooltipTypes.creditAuthorization:
        return 'Third Party Authorization Disclosure';
      case HTMLTooltipTypes.propertyTax:
        return 'Property Tax';
      case HTMLTooltipTypes.vaFundingFees:
        return 'VA Funding Fees';
      case HTMLTooltipTypes.refinanceGoals:
        return 'Refinance Goals';
      case HTMLTooltipTypes.propertyPurpose:
        return 'Property Type';
      case HTMLTooltipTypes.monthlyMortgagePayment:
        return 'Mortgage';
      case HTMLTooltipTypes.VAFixedRate:
        return 'VA Mortgage';
      case HTMLTooltipTypes.ConventionalFixedRate:
        return 'Conventional Loan';
      case HTMLTooltipTypes.offerDetailsRate:
        return 'Interest Rate';
      case HTMLTooltipTypes.offerDetailsAPR:
        return 'Annual Percentage Rate (APR)';
      case HTMLTooltipTypes.offerDetailsPoints:
        return 'Points';
      case HTMLTooltipTypes.offerDetailsCashToClose:
        return 'Cash to Close';
      case HTMLTooltipTypes.offerDetailsNewLoanAmount:
        return 'Total Loan Amount';
      case HTMLTooltipTypes.loanYouSelectedRateLock:
        return 'Rate Lock';
      case HTMLTooltipTypes.homeownersAssociation:
        return 'Homeowners Association';
      case HTMLTooltipTypes.voidedCheck:
        return 'Please upload a Voided Check:';
      case HTMLTooltipTypes.verifyAssets:
        return 'Instantly Verify Assets';
      case HTMLTooltipTypes.manufacturedHomePropertyType:
        return 'Manufactured Home Property Type';
      case HTMLTooltipTypes.manufacturedHomeOwnership:
        return 'Manufactured Home Ownership';
      default:
        return '';
    }
  }
}
